import _slicedToArray from "/home/javi/repos/infomerc/tasa-collectum/ecommerce/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React, { useCallback, useEffect, useMemo, useRef } from "react";
import styled, { css } from "styled-components";
import convertHexToRgba from "@kiwicom/orbit-design-tokens/lib/convertHexToRgba";
import mq from "../utils/mediaQuery";
import defaultTheme from "../defaultTheme";
import DrawerClose from "./components/DrawerClose";
import POSITIONS from "./consts";
import getPosition from "./helpers/getPosition";
import getTransitionAnimation from "./helpers/getTransitionAnimation";
import useTheme from "../hooks/useTheme";
import Stack from "../Stack";
import useStateWithTimeout from "../hooks/useStateWithTimeout";
import Heading from "../Heading";
import { rtlSpacing } from "../utils/rtl";

var getPadding = function getPadding(_ref3) {
  var noPadding = _ref3.noPadding,
      theme = _ref3.theme,
      hasTopPadding = _ref3.hasTopPadding;

  var padding = function padding(space) {
    return !hasTopPadding ? rtlSpacing("0 ".concat(space, " ").concat(space)) : space;
  };

  return !noPadding && css(["padding:", ";", ";"], padding(theme.orbit.spaceMedium), mq.largeMobile(css(["padding:", ";"], padding(theme.orbit.spaceXLarge))));
};

var StyledDrawer = styled.div.withConfig({
  displayName: "Drawer__StyledDrawer",
  componentId: "sc-1auf65o-0"
})(["display:flex;visibility:", ";position:fixed;top:0;left:0;right:0;bottom:0;width:100%;height:100%;background-color:", ";z-index:825;transition:background-color ", " ease-in-out;"], function (_ref4) {
  var overlayShown = _ref4.overlayShown;
  return overlayShown ? "visible" : "hidden";
}, function (_ref5) {
  var theme = _ref5.theme,
      shown = _ref5.shown;
  return shown ? convertHexToRgba(theme.orbit.paletteInkNormal, 50) : "transparent";
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.orbit.durationFast;
});
StyledDrawer.defaultProps = {
  theme: defaultTheme
};
var StyledDrawerSide = styled(function (_ref) {
  var theme = _ref.theme,
      width = _ref.width,
      position = _ref.position,
      shown = _ref.shown,
      suppressed = _ref.suppressed,
      props = _objectWithoutProperties(_ref, ["theme", "width", "position", "shown", "suppressed"]);

  return React.createElement("aside", props);
}).withConfig({
  displayName: "Drawer__StyledDrawerSide",
  componentId: "sc-1auf65o-1"
})(["display:block;position:absolute;box-sizing:border-box;top:0;bottom:0;height:100%;font-family:", ";overflow-y:auto;box-shadow:", ";background:", ";transition:transform ", " ease-in-out;width:100%;", ";", ";", ";"], function (_ref7) {
  var theme = _ref7.theme;
  return theme.orbit.fontFamily;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.orbit.boxShadowRaised;
}, function (_ref9) {
  var theme = _ref9.theme,
      suppressed = _ref9.suppressed;
  return suppressed ? theme.orbit.paletteCloudLight : theme.orbit.paletteWhite;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.orbit.durationNormal;
}, mq.largeMobile(css(["max-width:", ";"], function (_ref11) {
  var width = _ref11.width;
  return width;
})), getPosition, getTransitionAnimation);
StyledDrawerSide.defaultProps = {
  theme: defaultTheme
};
var StyledDrawerContent = styled(function (_ref2) {
  var theme = _ref2.theme,
      type = _ref2.type,
      hasTopPadding = _ref2.hasTopPadding,
      noPadding = _ref2.noPadding,
      hasClose = _ref2.hasClose,
      props = _objectWithoutProperties(_ref2, ["theme", "type", "hasTopPadding", "noPadding", "hasClose"]);

  return React.createElement("div", props);
}).withConfig({
  displayName: "Drawer__StyledDrawerContent",
  componentId: "sc-1auf65o-2"
})(["", ";margin-bottom:", ";margin-top:", ";"], getPadding, function (_ref12) {
  var theme = _ref12.theme,
      noPadding = _ref12.noPadding;
  return noPadding && theme.orbit.spaceLarge;
}, function (_ref13) {
  var hasClose = _ref13.hasClose,
      theme = _ref13.theme,
      noPadding = _ref13.noPadding;
  return !hasClose && noPadding && theme.orbit.spaceLarge;
});
StyledDrawerContent.defaultProps = {
  theme: defaultTheme
};
var StyledDrawerHeader = styled.div.withConfig({
  displayName: "Drawer__StyledDrawerHeader",
  componentId: "sc-1auf65o-3"
})(["display:flex;justify-content:flex-end;align-items:center;background:", ";height:64px;box-sizing:border-box;", ";", ";"], function (_ref14) {
  var suppressed = _ref14.suppressed,
      bordered = _ref14.bordered,
      theme = _ref14.theme;
  return suppressed && !bordered ? theme.orbit.paletteCloudLight : theme.orbit.paletteWhite;
}, function (_ref15) {
  var bordered = _ref15.bordered,
      theme = _ref15.theme;
  return bordered && css(["border-bottom:1px solid ", ";"], theme.orbit.paletteCloudNormal);
}, function (_ref16) {
  var noPadding = _ref16.noPadding,
      theme = _ref16.theme;
  return !noPadding && css(["padding:0 ", ";", ";"], theme.orbit.spaceMedium, mq.largeMobile(css(["padding:", ";"], rtlSpacing("0 ".concat(theme.orbit.spaceMedium, " 0 ").concat(theme.orbit.spaceXLarge)))));
});
StyledDrawerHeader.defaultProps = {
  theme: defaultTheme
};

var Drawer = function Drawer(_ref17) {
  var children = _ref17.children,
      onClose = _ref17.onClose,
      _ref17$shown = _ref17.shown,
      shown = _ref17$shown === void 0 ? true : _ref17$shown,
      _ref17$width = _ref17.width,
      width = _ref17$width === void 0 ? "320px" : _ref17$width,
      _ref17$position = _ref17.position,
      position = _ref17$position === void 0 ? POSITIONS.RIGHT : _ref17$position,
      dataTest = _ref17.dataTest,
      noPadding = _ref17.noPadding,
      suppressed = _ref17.suppressed,
      title = _ref17.title,
      actions = _ref17.actions;
  var theme = useTheme();
  var overlayRef = useRef(null);
  var timeoutLength = useMemo(function () {
    return parseFloat(theme.orbit.durationNormal) * 1000;
  }, [theme.orbit.durationNormal]);

  var _useStateWithTimeout = useStateWithTimeout(shown, timeoutLength),
      _useStateWithTimeout2 = _slicedToArray(_useStateWithTimeout, 3),
      overlayShown = _useStateWithTimeout2[0],
      setOverlayShown = _useStateWithTimeout2[1],
      setOverlayShownWithTimeout = _useStateWithTimeout2[2];

  var handleOnClose = useCallback(function (ev) {
    if (onClose && ev.target === overlayRef.current) {
      onClose();
    }
  }, [onClose]);
  useEffect(function () {
    if (overlayShown !== shown) {
      if (shown) {
        setOverlayShown(true);
      } else if (!shown) {
        setOverlayShownWithTimeout(false);
      }
    }
  }, [overlayShown, setOverlayShown, setOverlayShownWithTimeout, shown]);
  return React.createElement(StyledDrawer, {
    role: "button",
    overlayShown: overlayShown,
    shown: shown,
    onClick: handleOnClose,
    "data-test": dataTest,
    "aria-hidden": !shown,
    ref: overlayRef
  }, React.createElement(StyledDrawerSide, {
    shown: shown,
    width: width,
    position: position,
    role: "navigation",
    suppressed: suppressed
  }, (title || actions || onClose) && React.createElement(StyledDrawerHeader, {
    bordered: title || actions,
    suppressed: suppressed
  }, title && React.createElement(Heading, {
    type: "title2"
  }, title), actions && React.createElement(Stack, {
    spacing: "none",
    justify: "end",
    flex: true,
    shrink: true
  }, actions), onClose && React.createElement(DrawerClose, {
    onClick: onClose
  })), React.createElement(StyledDrawerContent, {
    noPadding: noPadding,
    hasClose: !!onClose,
    hasTopPadding: title || actions
  }, children)));
};

export default Drawer;